export const formatStepImageUrl = backgroundImageUrl => {
  if (backgroundImageUrl) {
    // Check if it's already a full URL
    if (
      backgroundImageUrl.startsWith('http://') ||
      backgroundImageUrl.startsWith('https://')
    ) {
      return backgroundImageUrl
    }
    // Check if it's a path (contains forward slash)
    else if (backgroundImageUrl.includes('/')) {
      return `${process.env.SITE_ASSET_URL}/${backgroundImageUrl}`
    }
    // Otherwise treat as UUID or simple filename
    else {
      // For UUIDs, we can't construct a valid CDN path without fetching image metadata
      // For now, prepend SITE_ASSET_URL and hope it works (will likely fail for UUIDs)
      return `${process.env.SITE_ASSET_URL}/${backgroundImageUrl}`
    }
  }
  return backgroundImageUrl
}
